import { createSelector } from '@reduxjs/toolkit';
import { selectConfiguration } from '@store/selectors/configurationSelectors';
import { getStockSaleParams, isValidStockSaleOrder } from '@utils/sales/vehicleStock';
import { selectIsUsedCar } from '@store/selectors/commonVehicleSelectors';
import {
  isForeignBrandOrder,
  isPcodeEnableForCurrentBrand,
  isStockSaleOrderToBeProcessed,
  isUsedImportCarsOrder,
} from 'next-common';
import { selectLeadMake, selectOrder } from '@store/selectors/order/base';
import { isEmpty } from 'lodash';

export const selectIsStockSaleOrder = createSelector([selectOrder, selectConfiguration], (order, configuration) => {
  return isValidStockSaleOrder(order, configuration);
});

export const selectIsForeignBrand = createSelector([selectOrder], (order) => {
  return isForeignBrandOrder(order);
});

export const selectIsNewCar = createSelector(
  [selectIsUsedCar, selectIsForeignBrand, selectOrder],
  (isUsedCar, isForeignBrand, order) => {
    return !isEmpty(order?.lead) && !isUsedCar && !isForeignBrand;
  }
);

export const selectIsVarebilEnabled = createSelector(
  [selectIsUsedCar, selectIsForeignBrand, selectConfiguration, selectOrder],
  (isUsedCar, isForeignBrand, configuration, order) => {
    return !isUsedCar && !isForeignBrand ? isPcodeEnableForCurrentBrand(configuration, { order }) : false;
  }
);

export const selectIsMerBrand = createSelector([selectIsUsedCar, selectLeadMake], (isUsedCar, make) => {
  return !isUsedCar && make === 'MER';
});

export const selectStockSaleParams = createSelector([selectOrder], (order) => {
  return getStockSaleParams(order);
});

export const selectIsStockSaleNEXTOrder = createSelector(
  [selectConfiguration, selectStockSaleParams],
  (configuration, stockSaleParams) => {
    return isStockSaleOrderToBeProcessed(configuration, stockSaleParams?.source, null, null);
  }
);

export const selectIsUsedImportCarOrder = createSelector([selectConfiguration, selectOrder], (configuration, order) => {
  return isUsedImportCarsOrder(configuration, order, order?.lead?.orderType, order?.vehicles?.[0]?.vehicleCondition);
});
